import axios from '@/plugins/axios'

export function getData() {
	return axios({
		url: 'friend/list',
		method: 'GET'
	})
}

export function addViewsByNickname(nickname) {
	return axios({
		url: 'friend/addViews',
		method: 'POST',
		params: {
			nickname
		}
	})
}

export function applyFriend(form) {
	return axios({
		url: 'friend/apply',
		method: 'POST',
		data: {
			...form
		}
	})
}